import { useTranslation } from 'react-i18next';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import HeadCheckbox from '@widgets/tables/main/HeadCheckbox';

export default function CustomTableHead({
  columns = [],
  params,
  setParams,
  selected,
  setSelected,
  data,
}) {
  const { t } = useTranslation();

  const rows = Array.isArray(data) ? data : [];
  const rowsIdSet = new Set(rows.map((row) => row.id));
  const selectedSet = new Set(selected?.map((item) => item.id));
  const pageSelectedCount = rows.reduce((count, row) => {
    return selectedSet.has(row.id) ? count + 1 : count;
  }, 0);

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const pageItems = rows.filter((row) => !selectedSet.has(row.id));
      setSelected([...selected, ...pageItems]);
    } else {
      const remaining = selected.filter((sel) => !rowsIdSet.has(sel.id));
      setSelected(remaining);
    }
  }

  const createSortHandler = (property) => () => {
    const isAsc = params.sort_by === property && params.sort_dir === 'asc';
    setParams({
      ...params,
      sort_by: property,
      sort_dir: isAsc ? 'desc' : 'asc',
      page: 1,
    });
  };

  const showCheckbox = typeof setSelected === 'function';

  return (
    <TableHead>
      <TableRow>
        {showCheckbox && (
          <HeadCheckbox
            pageSelectedCount={pageSelectedCount}
            onSelectAllClick={handleSelectAllClick}
            rowCount={rows.length}
          />
        )}

        {columns.map((cell) => {
          const active = params?.sort_by === cell.id;
          const direction = active ? params?.sort_dir : 'asc';

          return (
            <TableCell
              key={cell.id}
              style={{
                ...(cell.width && { width: cell.width }),
                ...(cell.minWidth && { minWidth: cell.minWidth }),
              }}
              align={cell.align}
              sortDirection={active ? params?.sort_dir : false}
            >
              {cell.sortable ? (
                <TableSortLabel
                  active={active}
                  direction={direction}
                  onClick={createSortHandler(cell.id)}
                >
                  <span dangerouslySetInnerHTML={{ __html: t(cell.label) }} />
                </TableSortLabel>
              ) : (
                <TableSortLabel hideSortIcon>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        cell.label &&
                        t(cell.label, { defaultValue: cell.label }),
                    }}
                  />
                </TableSortLabel>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
